import type {ApiCategory} from "./Category.ts";

/**
 * PartHistory.HistoryChoice
 */
export enum PartHistoryReason {
    input = 0,
    ai = 1,
    review = 2,
    internal_review = 3,
    approval = 4,
    unknown = 99,
}

export function partHistoryReasonToString(r: PartHistoryReason): string {
    switch (r) {
        case PartHistoryReason.input:
            return 'Input';
        case PartHistoryReason.ai:
            return 'AI';
        case PartHistoryReason.review:
            return 'Review';
        case PartHistoryReason.internal_review:
            return 'Internal review';
        case PartHistoryReason.approval:
            return 'Approval';
        case PartHistoryReason.unknown:
            return 'Unknown';
    }
    return '?';
}

/**
 * PartHistory.HistorySourceModel
 */
export enum PartHistoryRelatedObjectType {
    User = 1,
    AiCategorizationJob = 2,
    CategorizationApprovalRequest = 3,
    DataBag = 4,
}

export function partHistoryRelatedObjectTypeToString(type: PartHistoryRelatedObjectType | null): string {
    switch (type) {
        case PartHistoryRelatedObjectType.User:
            return 'User';
        case PartHistoryRelatedObjectType.AiCategorizationJob:
            return 'AI categorization job';
        case PartHistoryRelatedObjectType.CategorizationApprovalRequest:
            return 'Approval request';
        case PartHistoryRelatedObjectType.DataBag:
            return 'Databag';
        case null:
        case undefined:
            return '-';
    }
    return '?';
}

export type PartHistoryEntry = {
    id: number
    part_id: number
    category: ApiCategory
    reason: PartHistoryReason
    created_at: string
    related_object_type: PartHistoryRelatedObjectType | null
    related_object_id: number | null
}
